module.exports = __webpack_public_path__ + "img/c03_buildingtechriteofratis_Normal_ua.d1f9986f.webp";